import React from "react";

const BlogNewsletter = () => (
  <section className="w-full bg-white py-16 px-6 text-center">
    <h3 className="text-title text-dark-1 font-bold mb-4">
      📩 Recevez chaque mois les actus et projets de la communauté GoNextMaker
    </h3>
    <form className="max-w-lg mx-auto flex flex-col sm:flex-row gap-3">
      <input
        type="email"
        placeholder="Votre email"
        className="flex-1 px-4 py-3 rounded-full text-dark-1 border-2 border-dark-3 focus:outline-none"
      />
      <button
        type="submit"
        className="px-6 py-3 rounded-full border-2 border-blue-1 bg-blue-1 text-white hover:bg-white hover:text-blue-1 transition"
      >
        S’inscrire
      </button>
    </form>
  </section>
);

export default BlogNewsletter;
